import { signedFetch } from '../utils/signedFetch';

const GRAPHQL_ENDPOINT = import.meta.env.VITE_AWS_GRAPHQL_URL;

export const executeQuery = async (query, variables = {}) => {
  try {
    const response = await signedFetch(GRAPHQL_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query, variables }),
    });
    const result = await response.json();
    if (result.errors) {
      console.warn('GraphQL errors:', result.errors);
      if (!result.data) throw result.errors;
    }
    return result.data;
  } catch (error) {
    console.error('GraphQL Query Error:', error);
    throw error;
  }
};

export const executeMutation = async (mutation, variables = {}) => {
  try {
    const response = await signedFetch(GRAPHQL_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: mutation, variables }),
    });
    const result = await response.json();
    if (result.errors) throw result.errors;
    return result.data;
  } catch (error) {
    console.error('GraphQL Mutation Error:', error);
    throw error;
  }
};
